import { addCalendarItemsToStore } from '../actions/internalActions';
import store from '../store/store';
import { mutator } from 'satcheljs';

mutator(addCalendarItemsToStore, actionMessage => {
    // We need to reset calendar items before adding new items to the store. Since this
    // mutator is called whenever the user's calendar changes we need to remove stale events
    store.calendarItems.clear();
    for (const item of actionMessage.items) {
        store.calendarItems.set(item.ItemId.Id, item);
    }
});
